module.exports = __webpack_public_path__ + "img/Group.eeda9921.svg";